var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useFloating, useDismiss, useRole, useInteractions, FloatingFocusManager, offset, flip, shift, useHover, autoUpdate, useFocus, FloatingPortal, } from "@floating-ui/react";
const Tooltip = (_a) => {
    var { content, disabled = false, children, placement = "bottom-end", bottomGap = 8, open: controlledOpen, onOpenChange: setControlledOpen } = _a, props = __rest(_a, ["content", "disabled", "children", "placement", "bottomGap", "open", "onOpenChange"]);
    const [uncontrolledOpen, setUncontrolledOpen] = React.useState(false);
    const open = controlledOpen !== null && controlledOpen !== void 0 ? controlledOpen : uncontrolledOpen;
    const setOpen = setControlledOpen !== null && setControlledOpen !== void 0 ? setControlledOpen : setUncontrolledOpen;
    const { refs, floatingStyles, context } = useFloating({
        placement,
        open,
        onOpenChange: setOpen,
        whileElementsMounted: autoUpdate,
        middleware: [
            offset(bottomGap),
            flip({
                crossAxis: placement.includes("-"),
                fallbackAxisSideDirection: "start",
                padding: 5,
            }),
            shift({ padding: 5 }),
        ],
    });
    const hover = useHover(context, {
        move: false,
        enabled: controlledOpen == null,
    });
    const focus = useFocus(context, {
        enabled: controlledOpen == null,
    });
    const dismiss = useDismiss(context);
    const role = useRole(context, { role: "tooltip" });
    const { getReferenceProps, getFloatingProps, getItemProps } = useInteractions([role, hover, focus]);
    return (_jsxs(_Fragment, { children: [React.isValidElement(children) &&
                React.cloneElement(children, getReferenceProps(Object.assign(Object.assign(Object.assign({ ref: refs.setReference }, props), children.props), { "data-state": context.open ? "open" : "closed" }))), open && !disabled && (_jsx(FloatingPortal, { children: _jsx(FloatingFocusManager, { context: context, modal: false, children: _jsx("div", Object.assign({ ref: refs.setFloating, className: `bg-[#4E4E4E] flex z-30 justify-center shadow-[0_3px_8px_rgba(0,0,0,0.24)] rounded-md  px-2 py-1  w-max text-white text-xs flex`, role: "tooltip", "aria-orientation": "vertical", "aria-labelledby": "menu-button", tabIndex: "-1", style: Object.assign(Object.assign({}, floatingStyles), { background: "#4E4E4E", zIndex: 30 }) }, getFloatingProps(), { children: content })) }) }))] }));
};
export default Tooltip;
